import React from 'react';
import { Link } from 'react-router-dom';
import { LockKeyhole, ArrowUpRight } from 'lucide-react';
import { money } from '../api';

const PricingGate = ({ user }) => <div className="pricing-gate" data-testid="pricing-gate">
  <LockKeyhole size={23} /><div><h2>Better quantities. Business pricing.</h2>
    <p>{user ? 'Your business approval is required to view wholesale pricing.' : 'Sign in with an approved business account to view price tiers.'}</p>
    <Link to={user ? '/workspace' : '/auth'} data-testid="unlock-pricing">
      {user ? 'View application status' : 'Sign in to view pricing'} <ArrowUpRight size={14} />
    </Link>
  </div>
</div>;

const PriceTier = ({ tier, nextTier, unit, number }) => <div data-testid={`price-tier-${number}`}>
  <small>{tier.min_qty.toLocaleString()}{nextTier ? `–${nextTier.min_qty - 1}` : '+'} {unit}</small>
  <strong>{money(tier.price * 100)}</strong><span>per {unit}</span>
</div>;

export const ProductPricing = ({ product, user }) => {
  if (!product.pricing_visible) return <PricingGate user={user} />;
  return <div className="tier-prices">
    <div className="tier-heading"><h2>Wholesale pricing</h2><span>INR · excluding {product.gst_percent}% GST</span></div>
    <div className="tier-grid">{product.tiers.map((tier, index) => <PriceTier
      key={`${product.id}:${tier.min_qty}`} tier={tier} nextTier={product.tiers[index + 1]} unit={product.unit} number={index} />)}</div>
  </div>;
};